<template>
  <div class="member-withdraw">
    <div v-if="isWithdrawable">
      <el-row>
        <el-col align="center">
          本当に退会しますか？<br>
          退会を行うとこれまで保存していたデータがご利用いただけなくなります。
        </el-col>
      </el-row>
      <el-row style="padding-top: 2em">
        <el-col align="center">
          <el-button class="gtm_member_taikai_member" type="danger" @click="showDialog"><span class="gtm_member_taikai_member">退会する</span></el-button>
        </el-col>
      </el-row>
      <el-dialog :visible.sync="isShowDialog">
        <el-row>
          本当に退会しますか？<br>
          退会を行うとこれまで保存していたデータがご利用いただけなくなります。<br><br>
          ご依頼をお持ちの方はこちらから退会できませんので、レガシィ担当者にご連絡ください。<br>
          <router-link to="/contact" class="link-contact">ご連絡はコチラ</router-link>
        </el-row>
        <el-row>
          <el-col align="center" style="padding-top: 2em">
            <el-button type="danger" @click="isShowDialog = false">キャンセル</el-button>
            <el-button class="gtm_member_taikai_member" type="danger" @click="withdraw"><span class="gtm_member_taikai_member">退会する</span></el-button>
          </el-col>
        </el-row>
      </el-dialog>
    </div>
    <div v-else>
      <el-row>
        <el-col style="padding-bottom: 2em">
            対応中のご依頼があるため、退会できません。お手数ですが、契約情報のレガシィ担当者へご連絡ください。
        </el-col>
      </el-row>
      <anken-info></anken-info>
    </div>
  </div>
</template>

<script>
    import ApiAnken from '@/api/anken/anken-cl.js'
    import MemberApi from '@/api/member/member-client.js'
    import AnkenInfo from '../38_anken/AnkenInfo'
    import { LOGOUT_CLIENT } from '@/store/actions.type'
    import { isWithdrawable } from './ankenWithdrawalEligibility'

    export default {
        name: 'MemberWithdraw',
        components: { AnkenInfo },
        data () {
            return {
                isWithdrawable: false,
                isShowDialog: false
            }
        },
        created () {
            this.getAnkenList()
        },
        methods: {
            getAnkenList () {
                ApiAnken.getAnkenList().then(response => {
                  this.isWithdrawable = isWithdrawable(response.data)
                })
            },
            showDialog () {
                this.isShowDialog = true
            },
            async withdraw () {
              try {
                await MemberApi.withdraw()
              } catch (error) {
                this.isShowDialog = false
                this.alertMessage(error.response.data.message, 'エラー')
                return
              }
              this.$store.dispatch(LOGOUT_CLIENT).then(() => {
                this.$router.push({ name: 'portal' })
              })
            },
            alertMessage (message, title) {
                this.$alert(message, title, {
                    confirmButtonText: this.$t('commons.ok')
                })
            }
        }
    }
</script>

<style scoped>
  .member-withdraw {
    padding-top: 1em;
    padding-bottom: 2em;
  }
  .link-contact {
    font-size: 14px;
    text-decoration: underline;
    color: blue;
  }
  @media screen and (max-width:1024px) {
    .member-withdraw >>> .el-dialog {
      width: 50% !important;
    }
  }
  @media screen and (max-width:768px) {
    .member-withdraw >>> .el-dialog {
      width: 60% !important;
    }
  }
  @media screen and (max-width:480px) {
    .member-withdraw >>> .el-dialog {
      width: 90% !important;
    }
  }
</style>
